import tntControlComponent from './tnt_control.component';
import Configuration from './component/configuration';
import Setup from './component/setup';
import Shiptype from './component/shiptype';
import Denomination from './component/denomination';
import Currency from './component/currency';
import Message from './component/message';
import MobileApp from './component/mobile_app';
import UserPermissionReport from './component/user_permission_report'
import AtmLoadProfile from './component/atm_load_profile'
import CostCenter from './component/cost_center'
import EnvironmentConfig from './component/environment_config'
import LocationZone from './component/location_zone'
import NotificationManagement from './component/notification_management'
import ServiceAssignmentRules from './component/service_assignment_rules'

let tntControlModule = angular.module('tntControl', [ 
    Configuration,
    Setup,
    Shiptype,
    Denomination,
    Currency,
    Message,
    MobileApp,
    UserPermissionReport,
    AtmLoadProfile,
    CostCenter,
    EnvironmentConfig,
    LocationZone,
    NotificationManagement,
    ServiceAssignmentRules
  ])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
    .state('configuration', {
      url: '/configuration',
      component: 'configuration',
      parent:'tntControl',
      data: {
        requireLogin: true,
        requireACL: 'tnt_control_configuration.view'
      },
      resolve: {
        hasACL: () => ({})
      }
    })
    .state('setup', {
      url: '/branch-setup',
      component: 'setup',
      parent:'tntControl',
      data: {
        requireLogin: true,
        requireACL: 'tnt_control_branch_setup.view'
      },
      resolve: {
        hasACL: () => ({})
      }
    })
    .state('shiptype', {
      url: '/shiptype',
      component: 'shiptype',
      parent: 'tntControl',
      data: {
        requireLogin: true,
        requireACL: 'tnt_control_shiptype.view'
      },
      resolve: {
        hasACL: () => ({})
      }
    })
    .state('denomination', {
      url: '/denomination',
      component: 'denomination',
      parent: 'tntControl',
      data: {
        requireLogin: true,
        requireACL: 'tnt_control_denomination.view'
      },
      resolve: {
        hasACL: () => ({})
      }
    })
    .state('currency', {
      url: '/currency',
      component: 'currency',
      parent: 'tntControl',
      data: {
        requireLogin: true,
        requireACL: 'tnt_control_currency.view'
      },
      resolve: {
        hasACL: () => ({})
      }
    })
    .state('message', {
        url: '/message',
        component: 'message',
        parent: 'tntControl',
        data: {
          requireLogin: true,
          requireACL: 'tnt_control_message.view'
        },
        resolve: {
          hasACL: () => ({})
        }
      })
      .state('mobile_app', {
        url: '/mobile-app',
        component: 'mobileApp',
        parent: 'tntControl',
        data: {
          requireLogin: true,
          requireACL: 'tnt_control_mobile_app.view'
        },
        resolve: {
          hasACL: () => ({})
        }
      })
      .state('user_permission_report', {
        url: '/user-permission-report',
        component: 'userPermissionReport',
        parent: 'tntControl',
        data: {
          requireLogin: true,
          requireACL: 'tnt_control_user_permission_report.view'
        },
        resolve: {
          hasACL: () => ({})
        }
      })
      .state('atm_load_profile', {
        url: '/atm-load-profile',
        component: 'atmLoadProfile',
        parent: 'tntControl',
        data: {
          requireLogin: true,
          requireACL: 'tnt_control_atm_load_profile.view'
        },
        resolve: {
          hasACL: () => ({})
        }
      })
      .state('cost_center', {
        url: '/cost-center',
        component: 'costCenter',
        parent: 'tntControl',
        data: {
          requireLogin: true,
          requireACL: 'tnt_control_cost_center.view'
        },
        resolve: {
          hasACL: () => ({})
        }
      })
      .state('environment_config', {
        url: '/environment-config',
        component: 'environmentConfig',
        parent: 'tntControl',
        data: {
          requireLogin: true,
          requireACL: 'tnt_control_environment_config.view'
        },
        resolve: {
          hasACL: () => ({})
        }
      })
      .state('location_zone', {
        url: '/location-zone',
        component: 'locationZone',
        parent: 'tntControl',
        data: {
          requireLogin: true,
          requireACL: 'tnt_control_location_zone.view'
        },
        resolve: {
          hasACL: () => ({})
        }
      })
      .state('notification_management', {
        url: '/notification-management',
        component: 'notificationManagement',
        parent: 'tntControl',
        data: {
          requireLogin: true,
          requireACL: 'tnt_control_notification_management.view'
        },
        resolve: {
          hasACL: () => ({})
        }
      })
      .state('service_assignment_rules',{
        url: '/service-assignment-rules',
        component: 'serviceAssignmentRules',
        parent: 'tntControl',
        data:{
          requireLogin: true,
          requireACL: 'tnt_control_service_assignment_rules.view'
        },
        resolve: {
          hasACL: () => ({})
        }
      })
  })

  .component('tntControl', tntControlComponent)

  .name;

export default tntControlModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/index.js